'use client';

import dynamic from 'next/dynamic';

// The page navigation item depends on browser state, so it's never rendered on the server
const PageNavigationItemClientOnly = dynamic(
    () => import('@/components/Page/PageNavigationItem'),
    {
        ssr: false,
    },
);

export default PageNavigationItemClientOnly;
